import apiClient from '@/configs/config'

export const fetchAppVersionService = async () => {
    const response = await apiClient.post(
        '/customdata/getdata',
        {
            dataCode: 'SELECT_APP_VERSION',
            placeholderKeyValueMap: {}
        }
    )

    return response.data
}
